import { makeAutoObservable, runInAction } from 'mobx'
import type {
  IKeysUserPermissions,
  IResponseUserPermissions,
} from 'entities/UsersPermissions/api/types'
import { UsersPermissionsApi } from 'entities/UsersPermissions/api/usersPermissions'

export class UserPermissionsStore {
  initPromise
  private _setFinishInit: ((value?: unknown) => void) | null = null
  private _loading = true
  private _permissions: IResponseUserPermissions | null = null
  private _request: null | ReturnType<(typeof UsersPermissionsApi)['getUsersPermissions']> = null

  constructor() {
    this.initPromise = new Promise((resolve) => {
      this._setFinishInit = resolve
    })

    makeAutoObservable(this)
  }

  private _fetchUserPermissions = async () => {
    try {
      if (this._request) return this._request.then()
      runInAction(() => {
        this._loading = true
      })

      this._request = UsersPermissionsApi.getUsersPermissions()
      const { data: userPermissions } = await this._request

      runInAction(() => {
        this._permissions = userPermissions
      })
    } catch (e) {
      console.log(e)
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }

  fetchUserPermissions = async () => {
    await this._fetchUserPermissions()
    this._setFinishInit?.()
  }

  getItem = (key: IKeysUserPermissions) => {
    if (!this._permissions) return false

    return this._permissions[key]
  }

  updatePermissions = (permissions: IResponseUserPermissions) => {
    runInAction(() => {
      this._permissions = permissions
    })
  }

  get loading() {
    return this._loading
  }

  get canManageBilling() {
    return this.getItem('can_manage_billing_settings')
  }

  get can_manage_integrations() {
    return this.getItem('can_manage_integrations')
  }

  get canReassignConversations() {
    return this.getItem('can_reassign_conversations')
  }
}
